import type { MeasurementDataRequest } from 'commons';

/**
 * Action to retrieve channel data for a specific ID.
 */
export class GetChannelData {
  static readonly type = '[MultiView] Get Channel Data';

  /**
   * @param id - The unique identifier for the channel.
   * @param options - Optional parameters for the measurement data request.
   * @param parameter - Additional options, such as whether to replace the date.
   */
  constructor(
    public id: string,
    public options?: Partial<MeasurementDataRequest>,
    public parameter: { replaceDate: boolean } = { replaceDate: false }
  ) {}
}

/**
 * Action to retrieve channel data for multiple channels in a single batch request.
 */
export class GetBatchChannelData {
  static readonly type = '[MultiView] Get Batch Channel Data';

  /**
   * @param channelIds - Array of unique identifiers for the channels.
   * @param options - Optional parameters for the measurement data request.
   * @param parameter - Additional options, such as whether to replace the date.
   */
  constructor(
    public channelIds: string[],
    public options?: Partial<MeasurementDataRequest>,
    public parameter: { replaceDate: boolean } = { replaceDate: false }
  ) {}
}

/**
 * Action to check for missing channel data.
 */
export class CheckMissingChannelData {
  static readonly type = '[MultiLane] get missing channel data';
}

/**
 * Action to check in the background whether newer telemetry data than what is currently
 * rendered is available on the backend, without replacing the currently displayed data.
 */
export class CheckForNewTelemetryData {
  static readonly type = '[MultiView] Check For New Telemetry Data';
}

/**
 * Action to fetch and apply the newer telemetry data detected by `CheckForNewTelemetryData`,
 * replacing the data stored in IndexedDB and re-rendering the chart.
 */
export class LoadNewTelemetryData {
  static readonly type = '[MultiView] Load New Telemetry Data';
}

/**
 * Action to dismiss the "new data available" hint without fetching new data.
 */
export class DismissNewTelemetryData {
  static readonly type = '[MultiView] Dismiss New Telemetry Data';
}
